import { render } from "./phone.vue?vue&type=template&id=1128d1fa"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1128d1fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1128d1fa', __exports__)) {
    console.log('reload')
    api.reload('1128d1fa', __exports__)
  }
  
  module.hot.accept("./phone.vue?vue&type=template&id=1128d1fa", () => {
    console.log('re-render')
    api.rerender('1128d1fa', render)
  })

}


export default __exports__